module.exports = __webpack_public_path__ + "img/partner-bg.5b51b491.png";